import React from 'react';
import PropTypes from 'prop-types';
import { ScreenTransitionEffect } from '../../../routes';
import Button from '../../atoms/button';
import './style.scss';

const DefaultTemplate = ({ children, className }) => (
  <ScreenTransitionEffect>
    <div className="default-template">
      <div className="debug-nav hidden">
        <Button size="small" to="/identificacao">
          identificacao
        </Button>
        <Button size="small" to="/usuario-assinante">
          usuario-assinante
        </Button>
        <Button size="small" to="/usuario-nao-permitido">
          usuario-nao-permitido
        </Button>
        <Button size="small" to="/ativacao">
          ativacao
        </Button>
        <Button size="small" to="/ativacao/erro">
          ativacao/erro
        </Button>
        <Button size="small" to="/ativacao/sucesso">
          ativacao/sucesso
        </Button>
      </div>
      <div className={`content ${className}`}>{children}</div>
    </div>
  </ScreenTransitionEffect>
);

DefaultTemplate.defaultProps = {
  children: '',
  className: ''
};

DefaultTemplate.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default DefaultTemplate;
